/**
 * Custom Fields Tour
 *
 * Tutorial for custom fields on building/unit pages.
 * Every step anchors to real UI elements via data-tour attributes.
 */

import { TourDefinition } from '../config/tourSteps';

export const customFieldsTour: TourDefinition = {
  id: 'customFieldsTour',
  steps: [
    {
      element: '[data-tour="custom-fields-section"]',
      popover: {
        title: 'Aangepaste Velden',
        description:
          'Hier vindt u extra velden die niet in de standaard informatie passen, zoals "Aantal parkeerplaatsen" of "Type dak". Waarden worden per gebouw of unit opgeslagen.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="custom-fields-add"]',
      popover: {
        title: 'Veld Toevoegen',
        description:
          'Maak een nieuw veld aan. Kies uit tekst, nummer, dropdown of ja/nee. Dropdown-velden hebben vooraf gedefinieerde opties.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="custom-field-row"]',
      popover: {
        title: 'Veld Invullen',
        description:
          'Vul de waarde in of pas deze aan. Bij een sterretje-icoon is AI-extractie actief: de AI vult dit veld automatisch bij het analyseren van documenten.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="custom-field-ai-config"]',
      popover: {
        title: 'AI Configuratie',
        description:
          'Configureer hier welke bestandslabels de AI moet doorzoeken en welke prompt gebruikt wordt om de waarde te extraheren uit documenten.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
